export default class NotFoundError<Data = unknown> extends Error {
  name = 'NotFoundError';

  constructor(readonly message = 'Resource Not Found', readonly data?: Data) {
    super(message);
  }
}
